<template>
  <div class="resetPasswordWrapper">
    <div class="buttonBox">
      <Button :class="nowSwitch!==1?'ys-cancel':''" type="info" @click="handleSwitch(1)">重置密码</Button>&nbsp;&nbsp;
      <Button :class="nowSwitch!==2?'ys-cancel':''" type="info" @click="handleSwitch(2)">申请重置列表</Button>
    </div>
    <div class="contentBox">
      <component :is="nowComp"></component>
    </div>
  </div>
</template>
<script>
  import ResetPassword from "./resetPassword"
  import ResetPasswordList from "./resetPasswordList"

  export default {
    components: {
      ResetPassword,
      ResetPasswordList
    },
    data() {
      return {
        nowSwitch: 1,
        nowComp: 'ResetPassword'
      }
    },
    methods: {
      handleSwitch(id) {
        this.nowSwitch = id;
        if (id === 1) {
          this.nowComp = 'ResetPassword'
        } else {
          this.nowComp = 'ResetPasswordList'
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .resetPasswordWrapper {
    width: 100%;
    height: 100%;
    padding: 0 16px;

    .buttonBox {
      padding: 16px 32px;
      display: flex;
      justify-content: flex-end;
    }

    .contentBox {
      height: calc(100% - 120px);
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>